import { Component, ElementRef, ViewChild, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { AddressPart } from '@shared/models';
import { FormFieldComponent } from '../form-field.types';
import { ResearchService } from '@modules/research/research.service';

@Component({
  templateUrl: './text-form-field.component.html',
  styles: [
    `
      .mat-form-field {
        button {
          .mat-icon {
            min-width: 5px;
            width: 18px;
            min-height: 5px;
            height: 18px;
          }
        }
      }

      mat-form-field {
        input {
          opacity: 0.8;

          &:focus {
            opacity: 1;
          }
        }
      }
      .readonly {
        color: #6e6e6e !important;
        opacity: 1 !important;
      }
      input.blurred {
        filter: blur(2px);
        font-style: italic;
        letter-spacing: 2px;
      }
    `,
  ],
})
export class TextFormFieldComponent extends FormFieldComponent {
  @ViewChild('inputControl') inputControl: ElementRef;

  public editing: boolean = false;
  public value: string;

  private _originalValue: string;
  private _readonly: boolean;

  constructor(
    private readonly destroyRef: DestroyRef,
    private readonly resarchService: ResearchService,
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();

    this.value = this.fieldDef.meta?.value_hidden ? 'REDACTED' : this.model[this.fieldDef.name];
    this.updateMask();
    this._originalValue = this.value;

    if (this.fieldDef.meta && this.fieldDef.meta.readonly) {
      this._readonly = this.fieldDef.meta.readonly;
    }
    if (this.readonly) {
      this._readonly = this.readonly;
    }
    this.readonly = this._readonly;
  }

  edit(): void {
    if (!this.editing && !this._readonly) {
      this.editing = true;
      setTimeout(() => {
        this.inputControl?.nativeElement?.focus?.();
      }, 300);
    }
  }

  onBlur(): void {
    this.onSave();
    this.editing = false;
  }

  onSetAddress(event: AddressPart): void {
    if (event?.lat && event.lng) {
      const { lat, lng } = event;
      this.resarchService
        .reverseGeocode(null, lat, lng)
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((response) => {
          if (response && response.address) {
            this.updateModel();
            this.update.emit({
              [this.fieldDef.name]: response.address,
              address: response,
            });
          }
        });
    }
  }

  onNgModelChange(): void {
    this.updateMask();
  }

  updateChangedModel(model: any): void {
    this.model = model;
  }

  private onSave(): void {
    if (this._originalValue != this.value) {
      this.updateModel();
      this.update.emit({ [this.fieldDef.name]: this.value });
    }
  }

  private updateModel(): void {
    this.model[this.fieldDef.name] = this.value;
    this._originalValue = this.value;
  }

  private updateMask(): void {
    if (this.fieldMask) {
      this.mask$.next(this.fieldMask(this.value));
    }
  }
}
